import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, IconButton, InputBase, Modal, Stack, Typography } from "@mui/material";
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useDispatch, useSelector } from "react-redux";
import faradayApi from "../../../api/faradayApi";
import { useForm } from "../../../hooks";
import { closeModalChangePassword } from "../../../store/auth/authSlice";
import { ModalConfirm } from "./ModalConfirm";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '35%',
    maxWidth: 450,
    minWidth: 300,
    bgcolor: 'background.paper',
    borderRadius: '8px',
    boxShadow: 24,
    p: 4,
};

export const ModalRecover = () => {

    const { t } = useTranslation('global');
    const { changePassword } = useSelector(state => state.auth);
    const dispatch = useDispatch()
    const [correctPassword, setCorrectPassword] = useState(true);
    const [onConfirm, setOnConfirm] = useState(false);
    const handleClose = () => dispatch(closeModalChangePassword());
    const [formValues, handleInputChange, reset] = useForm({ repeatPassword: '', password: '' });
    const { password, repeatPassword } = formValues;

    const onSubmit = async (e) => {
        e.preventDefault();
        try {
            await faradayApi.post('/user/updatePassword', { password })
            handleClose()
            setOnConfirm(true)
        } catch (error) {
            reset()
        }
    }

    useEffect(() => {
        if (password === repeatPassword && password.length >= 4) {
            setCorrectPassword(true)
        } else {
            setCorrectPassword(false)
        }
    }, [password, repeatPassword])

    return (
        <>
            <Modal
                open={changePassword}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                sx={{ zIndex: 9999 }}
            >
                <Box sx={style}>
                    <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                        <Typography variant='h5' textAlign='center' fontWeight={700}>{t("createPassword.title")} </Typography>
                        <IconButton color='primary' onClick={handleClose}>
                            <CloseRoundedIcon />
                        </IconButton>
                    </Stack>
                    <form onSubmit={onSubmit} style={{ padding: '15px 5px', height: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>


                        <Typography variant='overline' color='secondary'>{t("createPassword.password")} </Typography>

                        <InputBase fullWidth
                            name="password"
                            size="small"
                            variant="standard"
                            type='password'
                            onChange={handleInputChange}
                            value={password}

                        />
                        <Typography variant='overline' color='secondary'>{t("createPassword.newPassword")}</Typography>
                        <InputBase fullWidth
                            name="repeatPassword"
                            size="small"
                            variant="standard"
                            type='password'
                            onChange={handleInputChange}
                            value={repeatPassword}
                            sx={{ marginBottom: 5 }}
                        />

                        <Button fullWidth disabled={!correctPassword} type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                        <Button fullWidth onClick={handleClose} variant="text">{t("createPassword.cancelButton")}</Button>
                    </form>

                </Box>
            </Modal>

            <ModalConfirm open={onConfirm} setOpen={setOnConfirm} />
        </>
    )
}
